export const muiPaperTheme = {
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: '16px',
      },
    },
  },
};
